var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-muted text-center mb-0 pt-3"},[_c('a',{class:_vm.textColor},[_vm._v(_vm._s(`版权所有 @ 2008-2024 1nc.`))]),_c('a',{staticClass:"pl-3 d-block d-md-inline",class:_vm.textColor,attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/recordQuery","target":"_blank"}},[_vm._v(_vm._s(_vm.info.filing_info))])])
}
var staticRenderFns = []

export { render, staticRenderFns }